import React from "react";
import HomePage from "../views/Home/Landing"

const PublicRoutes = [
  {
    path: "/",
    name: "Home",
    component: <HomePage/>,
  }
];

export default PublicRoutes;
